/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

;(function ScrollToTop() {
    /**
     * handles the visibility of the scroll to top button
     *
     * @constructor
     */
    function scrollToTop(dom) {
        /**
         * // local object availability
         * @type {scrollToTop}
         * @private
         */
        var _this = this

        /**
         * Distance after which the scrollToTop button should be visible
         * @type {number}
         * @private
         */
        this.offSetTop = window.innerHeight / 2

        /**
         * @method triggerScrollToTop
         * @returns {undefined}
         */
        this.triggerScrollToTop = function () {
            window.scrollTo(0, 0)
        }

        /**
         * @method scrollVisibility
         * @returns {undefined}
         */
        this.scrollVisibility = function () {
            if (document.body.scrollTop > _this.offSetTop || document.documentElement.scrollTop > _this.offSetTop) {
                dom.classList.remove('scroll-to-top__invisible')
            } else {
                dom.classList.add('scroll-to-top__invisible')
            }
        }

        /**
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            dom.onclick = function () {
                _this.triggerScrollToTop()
            }

            document.onscroll = function () {
                _this.scrollVisibility()
            }
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.bindEvents()
        }

        /**
         * initialize call
         */
        this.init()
    }

    // define the global scope
    if (!window.Energy) {
        window.Energy = {}
    }

    window.Energy.scrollToTop = scrollToTop
})()

if (document.readyState != 'loading') {
    var scrollToTopButton = document.querySelector('[data-js=scroll-to-top]')
    if (scrollToTopButton) {
        new window.Energy.scrollToTop(scrollToTopButton)
    }
} else {
    document.addEventListener('DOMContentLoaded', function () {
        var scrollToTopButton = document.querySelector('[data-js=scroll-to-top]')
        if (scrollToTopButton) {
            new window.Energy.scrollToTop(scrollToTopButton)
        }
    })
}
